<div id="catching-game">
  <h1>Catching Game App</h1>

  <button [disabled]="gameStarted" id="start-button" (click)="startGame()">START GAME</button>

  <div class="settings">
    <div class="settings-difficulty">
      <label>Difficulty </label>
      <button [disabled]="gameStarted || selectedLevel === 0" (click)="levelDown()">-</button>
      <p>{{selectedLevel + 1}}</p>
      <button [disabled]="gameStarted || selectedLevel === 2" (click)="levelUp()">+</button>
    </div>

    <div class="settings-color">
      <svg class="settings-ball-color">
        <circle cx="10" cy="10" r="10" [attr.fill]="circleColor" />
      </svg>
      <button [disabled]="gameStarted" (click)="changeBallColor()">Change ball color</button>

      <svg class="settings-player-color">
        <rect class="player" [attr.fill]="playerColor" />
      </svg>
      <button [disabled]="gameStarted" (click)="changePlayerColor()">Change player color</button>
    </div>
  </div>


  <div class="game-window">
    <svg>
      <circle [attr.cx]="ballX" [attr.cy]="ballY" r="10" [attr.fill]="circleColor" />
      <rect class="player" [attr.x]='catcher' y="490" [attr.fill]="playerColor" />
    </svg>
  </div>
  <div class="score" *ngIf="gameStarted">
    <h4>Score: </h4>
    <h3>{{currentScore}}</h3>
  </div>
  <p>*Use left and right arrow to move catcher</p>

  <div *ngIf="scoreList.length > 0">
    <h4>Score History</h4>
    <p *ngFor="let score of scoreList">{{score}}</p>
  </div>
</div>


<div class="not-supported-screen">
  <p>SMALLER SCREEN IS NOT SUPPORTED YET!</p>
</div>